import { Axios } from "../../../Api/axios";

// Category dashboard numbers — backend: CategoryPanelController (same
// api_token as every other /category/* call). Optional { from, to }
// (YYYY-MM-DD); without them everything is all-time.

const clean = (params = {}) =>
  Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== ""));

export const getCategoryAnalytics = (params) =>
  Axios.get("/category/analytics", { params: clean(params) }).then((r) => r.data);

export const getCategoryTopUsers = (params) =>
  Axios.get("/category/top-users", { params: clean(params) }).then((r) => r.data);

// The category's clock: running / paused / stopped (the admin starts it),
// the current cycle (collected, held, time left) and the status history.
export const getCategoryRun = () => Axios.get("/category/run").then((r) => r.data.data);

export const getCategoryCycles = () => Axios.get("/category/cycles").then((r) => r.data);

export const getCategoryWallet = (params) =>
  Axios.get("/category/wallet-transactions", { params: clean(params) }).then((r) => r.data);

export const errorMessage = (e, fallback = "Something went wrong") =>
  e?.response?.data?.message || fallback;
